export const MentionComponent = ({ id, name }) => {
  const user = {
    name,
    email: `${name.toLowerCase().replace(" ", ".")}@company.com`,
    avatar: `https://i.pravatar.cc/100?u=${id}`,
  };

  return (
    <span className="mention-wrapper">
      <span
        className=""
        style={{ display: "inline-flex", alignItems: "center" }}
      >
        <span>
          <img
            src={user.avatar}
            alt={user.name}
            className="rounded-full"
            style={{
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              marginRight: "4px",
            }}
          />
        </span>
        <span className="mention text-blue-600 cursor-pointer">{name}</span>
      </span>
      <span className="mention-card">
        <span className="mention-card-content">
          <img src={user.avatar} alt="" className="mention-avatar" />
          <span>
            <span className="mention-name">{user.name}</span>
            <span className="mention-email">{user.email}</span>
          </span>
        </span>
      </span>
    </span>
  );
};
